import { Report } from "../../api";

export const FETCH_REPORTS_INFO = "FETCH_REPORTS_INFO";

export interface FetchReportsInfoAction {
  type: typeof FETCH_REPORTS_INFO;
}

interface SetReportsAction {
  type: "SET_REPORTS_ACTION";
  data: Report[];
}

export type KnownAction =
  | FetchReportsInfoAction
  | SetReportsAction;

export const fetchReports = (): FetchReportsInfoAction =>
  ({ type: FETCH_REPORTS_INFO });

export const setReports = (data: Report[]): SetReportsAction =>
  ({ type: "SET_REPORTS_ACTION", data });
